/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {forkJoinDefaultIfEmpty} from '../../common/observable.utils';

@Injectable({
    providedIn: 'root'
})
export class GeoProcessingService {
    title = 'GeoProcessingService';

    callGeoProcessingService(url: any, parameters: any, synchronous: boolean) {
        const geoProcessor = new (window as any).esri.tasks.Geoprocessor(url);
        let observable: Observable<any>;

        if (synchronous) {
            observable = new Observable<any>(subscriber => {
                geoProcessor.execute(
                    parameters,
                    (result: any) => {
                        console.debug(`${this.title} - callGeoProcessingService - geoProcessor execute - success - result:`, result);
                        subscriber.next(result);
                        subscriber.complete();
                    },
                    (error: any) => {
                        console.error(`${this.title} - callGeoProcessingService - geoProcessor execute - error:`, error);
                        subscriber.error(error);
                    }
                );
            });
        } else {
            observable = new Observable<any>(subscriber => {
                geoProcessor.submitJob(
                    parameters,
                    (result: any) => {
                        console.debug(`${this.title} - callGeoProcessingService - geoProcessor submitJob - success - result:`, result);

                        forkJoinDefaultIfEmpty(
                            Object.entries(result.results)
                                .filter((kv: any[]) => kv[1])
                                .map((kv: any[]) => {
                                    const resultType = kv[1];
                                    const subject = new Subject<void>();
                                    const featureParameter = resultType.paramUrl.substring(8, resultType.paramUrl.length);
                                    geoProcessor.getResultData(result.jobId, featureParameter, (featureResult: any) => {
                                        resultType.featureResult = featureResult ? featureResult : [];
                                        subject.next();
                                        subject.complete();
                                    });
                                    return subject;
                                })
                        ).subscribe(() => {
                            subscriber.next(result);
                            subscriber.complete();
                        });
                    },
                    (result: any) => {
                        console.debug(`${this.title} - callGeoProcessingService - geoProcessor submitJob - status:`, result);
                        if (result.jobStatus === 'esriJobFailed') subscriber.error(result);
                    },
                    (error: any) => {
                        console.error(`${this.title} - callGeoProcessingService - geoProcessor submitJob - error:`, error);
                        subscriber.error(error);
                    }
                );
            });
        }

        return observable;
    }
}
